import { PropsWithChildren, ReactNode } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';
import { Paragraph } from './Text';
import { Skeleton } from './Skeleton';

const Container = styled(Box)`
	position: relative;
`;

const TopRight = styled(Box)`
	position: absolute;
	top: -4px;
	right: -4px;
`;

const Circle = styled(Flex)<{ $color: string; $large?: boolean }>`
	background: ${(props) => props.theme.colors[props.$color]};
	width: ${(props) => (props.$large ? '20px' : '16px')};
	height: ${(props) => (props.$large ? '20px' : '16px')};
	border-radius: ${(props) => (props.$large ? '10px' : '8px')};
	box-shadow: 0px 0px 0px 2px white;
	padding: 2px;
	justify-content: center;
	align-items: center;

	svg {
		display: block;

		pah {
			fill: ${(props) => props.theme.colors.white};
		}
	}

	${Paragraph} {
		font-size: 12px;
	}
`;

/**
 * A Status wraps its children in a container that also contains a status bubble
 * into the top-right corner.
 * @param props - props
 * @param props.badge - Badge
 * @returns Wrapped component
 */
function BadgeContainer(props: PropsWithChildren<BoxProps & { badge?: ReactNode }>) {
	const { badge, ...rest } = props;

	return (
		<Container {...rest}>
			{badge && <TopRight>{badge}</TopRight>}
			{props.children}
		</Container>
	);
}

export function Badge(props: { color: string; icon?: ReactNode; large?: boolean }) {
	return (
		<Circle $color={props.color} $large={props.large}>
			{props.icon}
		</Circle>
	);
}

Badge.Skeleton = styled(Skeleton.Box)<{ $large?: boolean }>`
	width: ${(props) => (props.$large ? '20px' : '16px')};
	height: ${(props) => (props.$large ? '20px' : '16px')};
`;

Badge.Container = BadgeContainer;
